enum BenefitImageType {
  banner = 1,
}

export default BenefitImageType;
